import * as React from 'react';
import { ExamplesPayload, SectionUIProps } from '~/common/types/types';
import { SectionLayout } from '~/components/common/common';
import { ExamplesList } from './components/components';

type Props = SectionUIProps & {
  payload: ExamplesPayload;
};

const Examples: React.FC<Props> = ({ payload }) => {
  const { title, items, techListTitle } = payload;

  return (
    <SectionLayout headingMessage={title}>
      <ExamplesList items={items} techListTitle={techListTitle} />
    </SectionLayout>
  );
};

export { Examples };
